import { render, staticRenderFns } from "./BlockType14Grid.vue?vue&type=template&id=65d2d6b1&scoped=true"
import script from "./BlockType14Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType14Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType14Grid.vue?vue&type=style&index=0&id=65d2d6b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d2d6b1",
  null
  
)

export default component.exports